module.exports = __webpack_public_path__ + "img/heic-icon-256x256@2x.62ce8db0.webp";